// Social Media venture maths — post content (costs energy, no cash up front), grow
// a following, and unlock brand deals at milestones. The audience itself becomes an
// ASSET: at each milestone a brand deal pays passive weekly income, week after week.

export const POST_ENERGY = 12; // energy a week's posting costs
const BASE_GAIN = 20; // new followers from a post, before the audience effect
const GROWTH = 0.12; // existing followers help bring more (audience compounds)
const DECAY = 0.95; // a week with no post lets the audience drift away a little

/** Brand-deal tiers: reach the milestone, earn that much passive income per week. */
export const BRAND_TIERS: { milestone: number; weekly: number }[] = [
  { milestone: 500, weekly: 10 },
  { milestone: 2000, weekly: 40 },
  { milestone: 10000, weekly: 150 },
];

/** Follower count after a week — posting grows it, silence lets it slip. */
export function socialGrowth(followers: number, posted: boolean): number {
  if (posted) return Math.round(followers + BASE_GAIN + followers * GROWTH);
  return Math.round(followers * DECAY);
}

/** Brand deals unlocked at this follower count + the total weekly passive income. */
export function brandDeals(followers: number): { tiers: typeof BRAND_TIERS; weeklyIncome: number } {
  const tiers = BRAND_TIERS.filter((t) => followers >= t.milestone);
  return { tiers, weeklyIncome: tiers.reduce((s, t) => s + t.weekly, 0) };
}

/** The next milestone the player is working toward (null once all are unlocked). */
export function nextMilestone(followers: number): { milestone: number; weekly: number } | null {
  return BRAND_TIERS.find((t) => followers < t.milestone) ?? null;
}
